import { render, staticRenderFns } from "./ShareAddress.vue?vue&type=template&id=53cf8b92"
import script from "./ShareAddress.vue?vue&type=script&lang=js"
export * from "./ShareAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports